import styled from 'styled-components';

export const StyledTitle = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  > span {
    font-size: 24px;
  }
`;
